import React, {useEffect, useState} from 'react';
import ScrollTrigger from "gsap/ScrollTrigger";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import gsap from "gsap";
import useNormalizedPosition from "@/Hooks/useNormalizedPosition";
import Line4 from "@/Components/Front/SVGS/Line4";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);


const Graph3= () => {
    const [progress, setProgress] = React.useState(0);
    const [pathLength, setPathLength] = useState();
    const lineRef = React.useRef(null);
    //
    //
    const [normalizedPosition, setMaxValue, setScrollProgress] = useNormalizedPosition();
    //
    //
    useEffect(() => {


        gsap.timeline({
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: "#line-4",
                // markers: {startColor: "white", endColor: "white"},
                scrub: true,
                start: "top center",
                end: "bottom center",
                onUpdate: self => {
                    setProgress(self.progress.toFixed(3));
                    setScrollProgress(self.progress.toFixed(3));
                }

            }
        })

    }, [])

    useEffect(
        () => {
            if (lineRef.current) {
                const pathLength = lineRef.current.getTotalLength();

                setPathLength(pathLength)
                setMaxValue(pathLength);
            }
        },
        [lineRef]
    )
    return (
        <div className={"graph-4"}>
            <Line4 ref={lineRef} normalizedPosition={normalizedPosition} pathLength={pathLength}/>
        </div>

    )
}

export default Graph3;
